import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { injectIntl } from "react-intl";

import Header from "./components/Header";
import Footer from "./components/Footer";

import LandingPage from "./LandingPage";
import AboutPage from "./sub-pages/AboutPage";
import PracticalityPage from "./sub-pages/PracticalityPage";
import InteractivityPage from "./sub-pages/InteractivityPage";
import AnalysisPage from "./sub-pages/AnalysisPage";
import ScrollToTop from "./components/ScrollToTop";

const LandingRouter = () => {
  useEffect(() => {
    document.body.classList.add("landingPageActive");
    return () => {
      document.body.classList.remove("landingPageActive");
    };
  }, []);

  return (
    <>
      <ScrollToTop />
      <Header />
      <div style={{ paddingTop: "76px" }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/sobre" element={<AboutPage />} />
          <Route path="/praticidade" element={<PracticalityPage />} />
          <Route path="/interatividade" element={<InteractivityPage />} />
          <Route path="/analise" element={<AnalysisPage />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default injectIntl(LandingRouter);

